import api from "api";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const useReopenTreatment = () => {
  const id = useId();
  return useMutation(() => api("POST /patients/{patient_id}/reopen_treatment", [id]));
};

export default useReopenTreatment;
